import { request } from '@umijs/max';

/** 客户方通讯资料，不关联平台用户账号。 */
export type CustomerContactInput = {
  /** 去除首尾空格后的姓名，1～100字符。 */
  contactName: string;
  /** 文本联系方式，1～100字符，保留前导零及分隔符。 */
  contactMethod: string;
};

/** 一个客户的联系人修改输入，当前仅允许一位；客户ID按字符串传递。 */
export type CustomerContactBatchItem = {
  /** 需要管理权限及机构归属校验的客户ID。 */
  customerId: string;
  /** 必须恰好包含一位联系人；保留列表结构供后续扩展。 */
  contacts: CustomerContactInput[];
};

/** 按客户计数的批量替换结果。 */
export type CustomerContactBatchResult = {
  /** 成功客户数。 */
  successCount: number;
  /** 失败客户数。 */
  failedCount: number;
  /** 不含个人通讯资料的客户级失败原因。 */
  failedItems: {
    /** 失败客户ID，以字符串接收长ID。 */
    customerId: string;
    /** 可供修正输入或权限的业务原因。 */
    reason: string;
  }[];
};

/**
 * 按客户独立事务完整替换客户方联系人；不修改我方联系人或账号。
 * @param items 1～200个不同客户的完整列表
 * @returns 成功客户数及失败客户明细
 */
export const batchReplaceCustomerContacts = (items: CustomerContactBatchItem[]) =>
  request<{
    /** 接口业务执行是否正常，部分失败仍为true。 */
    success: boolean;
    /** 接口失败时可展示的原因。 */
    message?: string;
    /** 按客户提交的执行统计。 */
    result?: CustomerContactBatchResult;
  }>('/admin/customer/contact/batch', { method: 'POST', data: { items } });
